var map = {
	"./Body-block.png": "d9b7",
	"./Body-block_small.png": "baaa",
	"./armholecurve.png": "107a",
	"./armholecurve_small.png": "65ab",
	"./bustline.png": "7425",
	"./bustline_small.png": "431c",
	"./cf-cb.png": "3702",
	"./cf-cb_small.png": "cf90",
	"./chestline.png": "e4c2",
	"./chestline_small.png": "fbeb",
	"./hipline.png": "ba45",
	"./hipline_small.png": "d8d8",
	"./maneken_back.png": "0495",
	"./maneken_back_merures.png": "839e",
	"./maneken_front.png": "ca36",
	"./maneken_front_merures.png": "3cba",
	"./maneken_pos_1.png": "6920",
	"./maneken_pos_1_back.png": "b789",
	"./maneken_pos_2.png": "2892",
	"./maneken_pos_2_back.png": "37b1",
	"./maneken_pos_3.png": "783d",
	"./maneken_pos_3_back.png": "f4b4",
	"./maneken_pos_4.png": "ec25",
	"./maneken_pos_4_back.png": "03a9",
	"./maneken_pos_5.png": "cd83",
	"./maneken_pos_5_back.png": "a8d1",
	"./maneken_pos_6.png": "e7c3",
	"./maneken_pos_6_back.png": "767c",
	"./maneken_pos_7.png": "b740",
	"./maneken_pos_7_back.png": "5909",
	"./maneken_pos_8.png": "6719",
	"./maneken_pos_9.png": "cc60",
	"./neckcurve.png": "f32a",
	"./neckcurve_small.png": "6ffa",
	"./rouler_positions_1.png": "a8d0",
	"./rouler_positions_1_back.png": "0761",
	"./rouler_positions_2.png": "7d22",
	"./rouler_positions_2_back.png": "5f5d",
	"./rouler_positions_3.png": "c24a",
	"./rouler_positions_3_back.png": "09de",
	"./rouler_positions_4.png": "4867",
	"./rouler_positions_4_back.png": "9f05",
	"./rouler_positions_5.png": "06bc",
	"./rouler_positions_5_back.png": "a0ee",
	"./rouler_positions_6.png": "2b9e",
	"./rouler_positions_6_back.png": "4112",
	"./rouler_positions_7.png": "019e",
	"./rouler_positions_7_back.png": "460e",
	"./rouler_positions_8.png": "f008",
	"./rouler_positions_9.png": "b324",
	"./rouler_positions_back.png": "990a",
	"./rouler_positions_front.png": "2884",
	"./shoulderseam.png": "81c8",
	"./shoulderseam_small.png": "7a7c",
	"./sideseam.png": "1fda",
	"./sideseam_small.png": "8263",
	"./waistline.png": "6611",
	"./waistline_small.png": "eb38"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ac77";